import * as React from 'react';

import type { DimeDetailLayoutTab } from '../DimeDetailLayout/DimeDetailLayout.types.js';
import { DETAILS_TAB } from './detail-layout-details-tab.js';

type UseDetailLayoutTabOptions = Readonly<{
  tabs: DimeDetailLayoutTab[];
  activeTab: string;
  onTabChange: (value: string) => void;
  rightPaneFolded: boolean;
  /** False until the layout's width is known, so a tab that only exists once the right pane folds isn't dropped on first paint. */
  measured: boolean;
  detailsTabLabel: string;
}>;

export function useDetailLayoutTab({
  tabs,
  activeTab,
  onTabChange,
  rightPaneFolded,
  measured,
  detailsTabLabel,
}: UseDetailLayoutTabOptions) {
  const visibleTabs = rightPaneFolded
    ? [{ value: DETAILS_TAB, label: detailsTabLabel }, ...tabs]
    : tabs;
  const currentTab = visibleTabs.some((tab) => tab.value === activeTab)
    ? activeTab
    : visibleTabs[0]?.value;
  React.useEffect(() => {
    if (measured && currentTab !== undefined && currentTab !== activeTab) onTabChange(currentTab);
  }, [measured, currentTab, activeTab, onTabChange]);
  return { visibleTabs, currentTab };
}
